import { render, staticRenderFns } from "./PaymentUpdater.vue?vue&type=template&id=28976876&scoped=true&"
import script from "./PaymentUpdater.vue?vue&type=script&lang=js&"
export * from "./PaymentUpdater.vue?vue&type=script&lang=js&"
import style0 from "./PaymentUpdater.vue?vue&type=style&index=0&id=28976876&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28976876",
  null
  
)

export default component.exports